import { Component, OnInit } from '@angular/core';
import { Constants } from '../Services/Constants';
import { HTTPService } from '../Services/http.service';
import { Observable } from 'rxjs/Observable';
import { filter } from '../App/search.pipe';
import { DatePipe } from "@angular/common";
import { MySharedService } from '../App/shared.service'

declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns?: any): void;

@Component({
    templateUrl: './AppViews/ProjectListReport/projectListReport.html'
})

export class ProjectListReportComponent implements OnInit {
    constants: Constants;
    projectListItems: any = [];
    teamItems: any[];
    projectTypeItems: any = [];
    projectStatusItems: any = [];
    userDetail: any;
    selfuser: boolean = true;
    filter: any = { 'TeamId': "", 'TypeId': "", 'StatusId': "" ,"SiteId":""};
    Search:any;
    siteItems:any;
    public showLoader = false;

    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private _datepipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
        this.filter.StatusId = this.constants.enumProjectStatus["Open"];
        this.filter.TeamId = "";
    }

    ngOnInit() {
        this.BindFilters();
        this.GetProjectList(true);
        this.getSite();
    }

    ExportItems() {
        debugger
        var exportList=JSON.parse(JSON.stringify(this.projectListItems));;
        var fil=new filter();
        exportList=fil.transform(exportList,this.Search);
        ExportToExcel(exportList, "Project List",
            ["ProjectCode", "Date", "Customer_Name", "Project_Title", "ProjectTypeName", "StageName","Since", "Estimated Time", "ActualTime", "Used","LastReview","Status_Comments"],
            ["Project Code", "Date", "Customer Name", "Project Title", "Project Type Name", "Stage Name", "Stage Since", "Planned", "Actual Time", "Used%","Last Review","Info"]);
    }


    GetProjectList(flag: boolean) {
        this.selfuser = flag;
        var UserId = 0;
        var TeamId = 0;
        if (this.userDetail.RoleId != 0) {
            UserId = this.userDetail.SiteUserId;
            //TeamId = this.userDetail.TeamID;
        }
        if (this.filter.TeamId == "") {
            TeamId = 0;
        }
        else {
            TeamId = this.filter.TeamId;
        }
        this.showLoader = true;
        this._httpService.ajaxPost("Project/GetProjectNew",
            {
                "ProjectId": 0,
                "OwnerTeamId": TeamId,
                "ProjectType": this.filter.TypeId,
                "Status": this.filter.StatusId,
                "UserId": UserId,
                "SiteId":this.filter.SiteId
            }).subscribe(
            data => {
                this.projectListItems = data["ProjectList"];
                this.projectListItems.forEach(element => {
                        if(element.Status_Comments!=null && element.Status_Comments!=""){
                            if(element.Status_Comments.length>=100){
                                // element.Status_Comments=element.Status_Comments.substring(0,100);
                                element.showcomments=true;
                                element.alteredComments=element.Status_Comments.substring(0,100)+"....";
                            }else{
                                 element.alteredComments=element.Status_Comments
                                element.showcomments=false;
                            }
                        }
                        if(element.ActualTime != null && element.ActualTime != "")
                        {
                            element.ActualTime = Math.round( element.ActualTime);
                        }
                    });
            },
            err => {
                console.log("GetProjectList Failed");
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },
            () => {
                console.log("GetProjectList " + this.selfuser);
                this.showLoader = false;

            }
            );
    }

    ngAfterViewInit() {
        $(".datemonthYear").datetimepicker({
            format: 'MM/YYYY'
        });
        $(".time").datetimepicker({
            format: 'HH:mm'
        });
        $("#show-filter").click(function () { $(".filter-form").slideToggle() });
    }
    BindFilters() {
        this.showLoader = true;
        this._httpService.ajaxPost('Team/GetAssignedTeam', { "TeamId": this.userDetail.TeamID, "UserId": this.userDetail.SiteUserId }).subscribe(
            data => {
                this.teamItems = data["AssignedTeam"];
            },
            err => {
                console.log("BindFilters Failed");

                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = true;
                this._httpService.ajaxPost('Common/GetParameter',
                    { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectType"] }).subscribe(
                    data => {
                        this.projectTypeItems = data["Parameter"];
                    },
                    err => {
                        console.log("BindFilters Failed");
                        this.showLoader = false;
                        this._sharedService.ShowMessage(this.constants.globalError);
                    },
                    () => {
                        this.showLoader = true;
                        this._httpService.ajaxPost('Common/GetParameter',
                            { "ParameterTypeId": this.constants.enumParamterTypeName["ProjectStatus"] }).subscribe(
                            data => {
                                this.projectStatusItems = data["Parameter"];

                            },
                            err => {
                                console.log("BindFilters Failed");

                                this.showLoader = false;
                                this._sharedService.ShowMessage(this.constants.globalError);
                            },

                            () => {
                            this.showLoader = false;

                            }

                            );
                        this.showLoader = false;

                    }
                    );
                this.showLoader = false;

            }
        );
    }

 public getSite() {
        this._httpService.ajaxPost('Common/GetSite', null).subscribe(
            data => {
                this.siteItems = data["Site"];
            }
        );
    }
    public clearFilter() {
        this.filter.TypeId = "";
        this.filter.TeamId = "";
        this.Search="";
        this.filter.StatusId = this.constants.enumProjectStatus["Open"];
    }

    showComments(ev,dt){
        console.log(ev);
        dt.flag=true;
        if(ev.srcElement.className=="showComments" && dt.flag==true){
            ev.srcElement.id="shwComments";
            $("#shwComments").tooltip('show');
        }
    }
    removeId(ev){
         if(ev.srcElement.className=="showComments" && ev.srcElement.id=="shwComments"){
            ev.srcElement.id="";
        }
    }
}


/** WEBPACK FOOTER **
 ** ./TypeScripts/ProjectListReport/projectListReport.component.ts
 **/